import { useEffect, useMemo, useState } from "react";
import { FormifyInputStyle } from "../../../../assets/styles";
import req from "../../../../modules/Request";
import { clsx } from "../../../../modules/Utilkit/Utilkit";
import { useNotify } from "../../../components/Notify";


const MilestoneFormEdit = ({task, setTasks, holidays, onClose, workingHours, tasks}) => {
	const {notify} = useNotify();

	const [start, setStart] = useState(task.start);
	const [label, setLabel] = useState(task.name === task.origin ? '' : task.name);
	const [sequence, setSequence] = useState(task.sequence || 1);

	useEffect(() => {
		setStart(task.start);
		setLabel(task.name === task.origin ? '' : task.name);
	}, [task]);

	const reqData = useMemo(() => {
		const data = {...task};
		data.label = label;
		data.start = start;
		data.date = start;
		data.sequence = sequence;
		data.position = sequence;

		return data;
	}, [start, label, sequence]);

	const handleSubmit = (e) => {
		e.preventDefault();

		if (holidays.includes(start)) {
			notify('Data Inizio', "La data non può essere un giorno festivo.", 'error');
			return;
		}

		const fatherPosition = task.position.split('.').slice(0, -1).join('.');

		const taskWithSamePosition = tasks.find(t => t.position === fatherPosition + '.' + reqData.sequence && +t.id !== +task.id);

		req('sync-task', {task: reqData, taskWithSamePositionId: taskWithSamePosition?.id ?? null}).then(async (res) => {
			if (res.success) {
				setTasks(tasks => tasks.map(t => {
					if (+t.id === +task.id) {
						return {
							...reqData,
							moved: 1,
							name: reqData.label || task.origin,
							position: task.position.split('.').slice(0, -1).join('.') + '.' + reqData.sequence,
							sequence: reqData.sequence
						};
					} else if(+t.id === +taskWithSamePosition?.id) {
						return {
							...t,
							position: fatherPosition + '.' + task.sequence,
							sequence: task.sequence
						};
					} else {
						return t;
					}
				}));
			} else {
				notify(res.error, "Errore durante l'aggiornamento del task.", 'error');
			}
		});

		onClose();
	};

	return (
		<form className="min-w-[220px] flex flex-col items-center text-center" onSubmit={handleSubmit}>
			<div className="w-full font-semibold border-b border-gray-400">Modifica Task</div>

			<div className="flex flex-col justify-center items-center space-y-1 pb-2">
				<div className="flex flex-col w-full">
					<label>Titolo</label>

					<input
						disabled={task.record !== "M"}
						className={FormifyInputStyle}
						maxLength={50}
						placeholder={task.origin}
						value={label}
						onInput={(e) => task.record === 'M' && setLabel(e.target.value)}
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Data</label>

					<input required
								 type="date"
								 className={FormifyInputStyle}
								 value={start}
								 onInput={(e) => {
									 if (!holidays.includes(e.target.value)) {
										 setStart(e.target.value);
									 } else {
										 notify('Data Inizio', "La data non può essere un giorno festivo.", 'error');
									 }
								 }}
					/>
				</div>

				<div className="flex flex-col w-full">
					<label>Sequenza</label>

					<input
						className={FormifyInputStyle}
						required={true}
						min={1}
						step={1}
						type="number"
						onInvalid={(e) => {
							e.preventDefault();
							notify('Errore', e.target.validationMessage, 'error');
						}}
						value={sequence}
						onInput={(e) => {
							setSequence(e.target.value);
						}}
					/>
				</div>

				<button
					className={clsx(
						"border disabled:bg-green-300 disabled:border-green-200 rounded-sm",
						"px-4 py-0.5 duration-75 bg-green-500 hover:bg-green-400 border-green-400",
						"hover:border-green-300 text-white"
					)}
				>
					Salva
				</button>
			</div>
		</form>
	);
};

export default MilestoneFormEdit;